import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { TrustRow } from "./components/site/TrustRow";
import { Services } from "./components/site/Services";
import { Pricing } from "./components/site/Pricing";
import { Audience } from "./components/site/Audience";
import { Areas } from "./components/site/Areas";
import { AboutMats } from "./components/site/AboutMats";
import { WorkReviews } from "./components/site/WorkReviews";
import { WorkGallery } from "./components/site/WorkGallery";
import { QuoteForm } from "./components/site/QuoteForm";
import { Footer } from "./components/site/Footer";
import { MobileBar } from "./components/site/MobileBar";

function App() {
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-[var(--ink)] focus:px-4 focus:py-2 focus:text-white"
      >
        Hoppa till innehållet
      </a>
      {"\n"}
      <Header />
      {"\n"}
      <main id="main">
        {"\n  "}
        <Hero />
        {"\n  "}
        <TrustRow />
        {"\n  "}
        <Services />
        {"\n  "}
        <Pricing />
        {"\n  "}
        <Audience />
        {"\n  "}
        <Areas />
        {"\n  "}
        <AboutMats />
        {"\n  "}
        <WorkGallery />
        {"\n  "}
        <WorkReviews />
        {"\n  "}
        <QuoteForm />
        {"\n"}
      </main>
      {"\n"}
      <Footer />
      {"\n"}
      <MobileBar />
    </>
  );
}

export default App;
